
























































































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { IBlueprint, ISegment, LoadState, Offer, IABTest } from '@/store/types';
import { capitalizeFirstLetter, LOAD_STATE, romanize } from '@/store/shared';
import { ascending } from 'd3-array';
import { FETCH_SEGMENT_SESSION_COUNTS } from '../../store/action-types';

enum SegmentState {
  disabled = 'disabled',
  setup = 'setup',
  collecting = 'collecting',
  active = 'active',
}

export default Vue.extend({
  name: 'CancelFlowCard',
  components: {},
  props: {
    blueprintId: {
      type: String,
    },
    segmentId: {
      type: String,
    },
  },
  data() {
    return {
      LOAD_STATE,
      SegmentState,
    };
  },
  async created() {
    this.$store.dispatch(FETCH_SEGMENT_SESSION_COUNTS);
  },
  computed: {
    ...mapGetters(['abTests', 'publishedBlueprintMatchesActive']),
    sessionCount(): number {
      if (this.segmentId) {
        return this.$store.state.segmentSessionCounts?.[this.segmentId] || 0;
      }
      return this.$store.state.segmentSessionCounts?.['null'] || 0;
    },
    blueprint(): IBlueprint | undefined {
      if (!this.blueprintId) {
        return undefined;
      }
      return this.$store.state.blueprints[this.blueprintId];
    },
    unpublishedChanges(): boolean {
      if (this.blueprint) {
        return !this.publishedBlueprintMatchesActive(this.blueprint._id);
      }
      return false;
    },
    primaryNeedsPublishing(): boolean {
      if (!this.segment && !this.$store.state.org?.activeBlueprint) {
        return true;
      }
      return false;
    },
    segment(): ISegment | undefined {
      if (!this.segmentId) {
        return undefined;
      }
      return this.$store.state.segments[this.segmentId];
    },
    segmentInABTest(): boolean {
      return this.abTests.find((item: IABTest) => item.segments.includes(this.segmentId) && !item.completedAt);
    },
    segmentState(): SegmentState {
      if (this.segment) {
        if (this.segment.deleted || !this.segment.enabled) {
          return SegmentState.disabled;
        }
        if (!this.segment.activeBlueprint) {
          return SegmentState.setup;
        }
        return SegmentState.active;
        // return SegmentState.collecting;
      }
      return SegmentState.active;
    },
    blueprintLoadState(): LoadState {
      if (this.blueprintId) {
        return this.blueprint?.loadState || LOAD_STATE.UNLOADED;
      }
      return LOAD_STATE.LOADED;
    },
    segmentLoadState(): LoadState {
      if (this.segmentId) {
        return this.segment?.loadState || LOAD_STATE.UNLOADED;
      }
      return LOAD_STATE.LOADED;
    },
    loadState(): LoadState {
      if (this.blueprintLoadState === LOAD_STATE.LOADED && this.segmentLoadState === LOAD_STATE.LOADED) {
        return LOAD_STATE.LOADED;
      }
      return LOAD_STATE.LOADING;
    },
    offersDescription(): string {
      if (this.blueprintId) {
        const offers = this.$store.getters.blueprintOffers(this.blueprintId) as Offer[];
        const uniqueOfferStrings = [...new Set(offers.map((o) => this.$store.getters.blueprintOfferToString(o)))];
        if (uniqueOfferStrings.length) {
          return uniqueOfferStrings.sort(ascending).join(' • ');
        }
        return 'None';
      }
      return 'None';
    },
    audienceDescription(): string {
      if (this.segment) {
        const filters = this.segment.filter || [];
        const filterStrings = filters.map((f) => this.$store.getters.segmentFilterToString(f));
        if (filterStrings.length) {
          if (filterStrings.length > 1) {
            return filterStrings.map((s, i) => `(${romanize(i + 1).toLowerCase()}) ${capitalizeFirstLetter(s.toLowerCase())}`).join(', and ');
          }
          return capitalizeFirstLetter(filterStrings.join(' & ').toLowerCase());
        }
      } else {
        return 'Customers who do not belong to any other segmented cancel flow';
      }
      return 'To be defined';
    },
  },
});
